import API from "./API";

class User {
  static async getProfile() {
    return API.get("/public/users/profile", { needAuth: true });
  }

  static async updateProfile(data) {
    return API.put("/public/users/profile", data, { needAuth: true });
  }

  static async changePassword(data) {
    return API.post("/public/users/change-password", data, { needAuth: true });
  }

  static async resetPassword(data) {
    return API.post("/public/users/reset-password", data);
  }

  static async requestResetPassword(data) {
    return API.post("/public/users/reset-password/request", data);
  }

  static async register(data) {
    return API.post("/public/users", data);
  }

  static async confirmAccount(data) {
    return API.post("/public/users/confirm-account", data);
  }
}

export default User;
